import React, { useState } from "react";
import KuikaColorPicker from "../../../../ui-kit/kuika-color-picker/kuika-color-picker";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

interface IStatefulColorProps {
  initial?: string;
  position?: "top" | "bottom";
}

const Stateful: React.FC<IStatefulColorProps> = ({ initial = "#1890FF", position }: IStatefulColorProps) => {
  const [color, setColor] = useState<string>(initial);
  return <KuikaColorPicker color={color} onChange={(c: string) => setColor(c)} position={position} />;
};

export const ColorPickerStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Color Picker"
      componentName="KuikaColorPicker"
      sourcePath="ui-kit/kuika-color-picker"
      description="Sketch-style picker with 16 preset swatches. Click the swatch to open the picker — closes on outside click."
    >
      <SpecRow
        label="Default"
        caption="opens below — trigger on the md rung (32px), panel on the overlay elevation"
        align="center"
      >
        <Stateful initial="#1890FF" />
        <Stateful initial="#F5222D" />
        <Stateful initial="#52C41A" />
        <Stateful initial="transparent" />
      </SpecRow>
      <SpecRow label="Position above" caption="position='top'" align="center">
        <div style={{ paddingTop: 220 }}>
          <Stateful initial="#722ED1" position="top" />
        </div>
      </SpecRow>
      <SpecRow label="Preset palette" caption="16 named tokens including transparent">
        <div className="lab-row" style={{ gap: 6, flexWrap: "wrap", maxWidth: 480 }}>
          {KuikaColorPicker.presetColors.map((preset: string) => (
            <div
              key={preset}
              style={{
                width: 26,
                height: 26,
                background:
                  preset === "transparent"
                    ? "repeating-conic-gradient(#ccc 0% 25%, #fff 0% 50%) 50% / 8px 8px"
                    : preset,
                border: "1px solid var(--lab-border-strong)"
              }}
              title={preset}
            />
          ))}
        </div>
      </SpecRow>
    </ShowcaseFrame>
  );
};
